export const tabs = [
  { tab:'game', text: 'Games' },
  { tab:'app', text: 'Apps' },
  { tab:'file', text: 'Movies' },
  { tab:'book', text: 'Books' },
  { tab:'child', text: 'Kids' }
]

export enum STYLE_TEMPLATE {
  style_1 = 'first',
  style_2 = 'second',
  style_3 = 'third',
}

export const STYLE_TEMPLATE_COLOR = {
  style_1: '#fff',
  style_2: '#111611',
  style_3: '#111611',
}

export type StyleKey = keyof typeof STYLE_TEMPLATE;